<template>
    <div :class="['ffimg',{ffimgstatic:isstatic}]">
        <img :src="imgsrc" class="noviewer" />
        <span class="imgzoom"><img :src="imgsrc" /></span>
    </div>
</template>

<script>
    export default {
        name: 'ffimg',
        props: {
            imgsrc: {
                type: String,
                default: ''
            },
            isstatic: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
    .ffimg { width: 100%; position: relative; display: block; overflow: hidden; flex: none }
    .ffimgstatic { height: 100%; overflow: hidden }
    .ffimg img { width: 100%; height: 100%; border-radius: 10px; }
    .ffimgstatic img { object-fit: cover }
    .ffimg .imgzoom { display: block; position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; overflow: hidden; border-radius: 10px; }
        .ffimg .imgzoom img { width: 100%; height: 100%; transition: all .5s ease; }
            .ffimg .imgzoom img:hover { transform: scale(1.1) }
</style>
